import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Card,
  Spinner,
  Alert,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useGetProductsByNameQuery } from "../slices/productApiSlice";

const ProductSearchScreen = () => {
  const navigate = useNavigate();

  const [keyword, setKeyword] = useState("");
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [sort, setSort] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const pageSize = 10;

  const { data, isLoading, isError, error, refetch } =
    useGetProductsByNameQuery({
      keyword,
      minPrice,
      maxPrice,
      sort,
      pageNumber,
      pageSize,
    });

  const handleSearch = () => {
    setPageNumber(1);
    refetch();
  };

  const goToProductDetail = (id) => {
    navigate(`/product/${id}`);
  };

  return (
    <Container className="mt-4">
      <Row className="mb-3">
        <Col>
          <Button variant="outline-primary" onClick={() => navigate("/Home")}>
            ← Back to Home
          </Button>
        </Col>
      </Row>

      <h2 className="mb-4 text-center">Product Search</h2>

      {/* Search Filters */}
      <Form className="mb-4">
        <Row className="g-2">
          <Col xs={12} sm={6} md={3}>
            <Form.Control
              type="text"
              placeholder="Search..."
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
            />
          </Col>
          <Col xs={12} sm={6} md={3}>
            <Form.Control
              type="number"
              placeholder="Min Price"
              value={minPrice}
              onChange={(e) => setMinPrice(e.target.value)}
            />
          </Col>
          <Col xs={12} sm={6} md={3}>
            <Form.Control
              type="number"
              placeholder="Max Price"
              value={maxPrice}
              onChange={(e) => setMaxPrice(e.target.value)}
            />
          </Col>
          <Col xs={12} sm={6} md={3}>
            <Button onClick={handleSearch} variant="primary" className="w-100">
              Search
            </Button>
          </Col>
        </Row>
      </Form>

      {/* Sort Options */}
      <Row className="mb-3">
        <Col className="d-flex gap-2 justify-content-center">
          <Button
            variant={sort === "asc" ? "success" : "outline-success"}
            onClick={() => {
              setSort("asc");
              refetch();
            }}
          >
            Sort: Low to High
          </Button>
          <Button
            variant={sort === "desc" ? "danger" : "outline-danger"}
            onClick={() => {
              setSort("desc");
              refetch();
            }}
          >
            Sort: High to Low
          </Button>
        </Col>
      </Row>

      {/* Loading */}
      {isLoading && (
        <div className="text-center my-5">
          <Spinner animation="border" variant="primary" />
        </div>
      )}

      {/* Error */}
      {isError && (
        <Alert variant="danger">
          Error: {error?.data?.message || "Failed to load products"}
        </Alert>
      )}

      {/* Product List */}
      <Row xs={1} sm={2} md={3} lg={4} className="g-4">
        {data?.products?.map((product) => (
          <Col key={product._id}>
            <Card
              className="h-100"
              onClick={() => goToProductDetail(product._id)}
              style={{ cursor: "pointer" }}
            >
              <Card.Body>
                <Card.Title>
                  {product.Tamil} - {product.name}
                </Card.Title>
                <Card.Text>
                  <strong>Price:</strong> ₹{product.price}
                  <br />
                  <strong>Category:</strong> {product.category}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Pagination */}
      {data?.pages > 1 && (
        <Row className="mt-4 justify-content-center align-items-center">
          <Col xs="auto">
            <Button
              variant="secondary"
              onClick={() => setPageNumber((prev) => Math.max(prev - 1, 1))}
              disabled={pageNumber === 1}
            >
              Previous
            </Button>
          </Col>
          <Col xs="auto">
            <strong>
              Page {pageNumber} of {data.pages}
            </strong>
          </Col>
          <Col xs="auto">
            <Button
              variant="secondary"
              onClick={() => {
                if (pageNumber < data.pages) {
                  setPageNumber((prev) => prev + 1);
                }
              }}
              disabled={pageNumber >= data.pages}
            >
              Next
            </Button>
          </Col>
        </Row>
      )}
    </Container>
  );
};

export default ProductSearchScreen;